import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Components/Login/Login";
import MainQuiz from "./Components/MainQuiz";
import MockQuiz from "./Components/MockQuiz";
import Home from "./Components/Landing/LandingPage";
import "./app.css";
import NotFound from "./Components/NotFound";
import QuizSelect from "./Components/QuizSelect";
import Certificate from "./Components/Certificate/Certificate";
const App = () => {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/certificate" element={<Certificate />} />
          {/* <Route exact path="/login" element={<Login />} />
          <Route exact path="/signup" element={<Login />} />
          <Route exact path="/forgot-password" element={<Login />} />
          <Route exact path="/quiz" element={<QuizSelect />} />
          <Route exact path="/quiz/main" element={<MainQuiz />} />
          <Route exact path="/quiz/mock" element={<MockQuiz />} /> */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
